'use strict'
module.exports = require('./lib/api')(require('./lib/keccak'))



//////////////////
// WEBPACK FOOTER
// ./~/keccak/js.js
// module id = 1468
// module chunks = 0 1 2